const DEFAULT_MCP_SERVER_ICON = 'mcp';

const MCP_SERVER_FALLBACK_ICONS: Readonly<Record<string, string>> = {
  'forge-bash': 'terminal',
  'forge-discovery': 'light-forge',
  'forge-typesense': 'light-typesense',
  'forge-filesystem': 'folder-tree',
  playwright: 'light-playwright',
};

export type McpServerIconOverride = {
  icon?: string;
};

/**
 * Returns the Font Awesome icon name for an MCP server by name.
 * Prefers a DB-backed catalog `icon`; otherwise uses the known-server fallback, then `mcp`.
 * Icons render with Font Awesome Light (`fal`).
 * @param serverName MCP server name from a `{serverName}__{toolName}` tool key.
 * @param override Optional catalog row fields, typically `McpServer.icon`.
 * @returns Font Awesome icon name without the `fal` prefix.
 */
export function getMcpServerIcon(serverName: string, override?: McpServerIconOverride): string {
  if (override?.icon) {
    return override.icon;
  }

  return MCP_SERVER_FALLBACK_ICONS[serverName] ?? DEFAULT_MCP_SERVER_ICON;
}
